import { render, staticRenderFns } from "./clickThankYou.vue?vue&type=template&id=e4d9d71a&scoped=true"
import script from "./clickThankYou.vue?vue&type=script&lang=js"
export * from "./clickThankYou.vue?vue&type=script&lang=js"
import style0 from "./clickThankYou.vue?vue&type=style&index=0&id=e4d9d71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d9d71a",
  null
  
)

export default component.exports